import { MAIN_COLOR } from '@/scripts/colorTheme.js';

export default {
    VERSION: '1.0.7',

    ROUTER_NAME: {
        SETTING: 'setting',
        MAIN: 'main',
        AUTHORIZATION: 'authorization',
        FILEEDIT: 'fileEdit',
        USEREDIT: 'userEdit',
        PROVIDERANDGAMEEDIT: 'providerAndGameEdit',
        GUPUPLOADS: 'gupUploads',
        TAGEDIT: 'tagEdit',
        CHATGPTEDIT: 'chatGPTEdit',
        FILTEREDIT: 'filterEdit',
        CHANGELOG: 'changeLog',
        ASSETTYPE: 'assetType',
        SMARTFILTER: 'smartFilter',
        TESTEMAILS: 'testEmails',
        ANTIFRAUD: 'antifraud',
        BILLING: 'billing',
        CORPORATEREQUESTS: 'corporateRequests',
        USERANALYTICS: 'userAnalytics',
        USERANALYTICSWITHUSER: 'userAnalyticsWithUser',
        SYSTEMANALYTICS: 'systemAnalytics',
        SYSTEMSETTINGS: 'systemsettings',
        // [Epic1/#869c5bjxn] Publisher Admin
        PUBLISHER_MATERIAL_REQUESTS: 'publisherMaterialRequests',
        PUBLISHER_MANAGEMENT: 'publisherManagement',
        PROVIDER_MANAGEMENT: 'providerManagement',
        // Partner link system
        PARTNERS: 'partners',
        TEST_LANDING: 'testLanding',
    },
    ANALYTICS_TABS: {
        GENERAL: 'general',
        SEARCH_QUERIES: 'search_queries',
    },
    SEARCH_QUERY_PAGINATION_OPTIONS: [50, 100, 200, 500],
    IMAGE_NAME: 'Images',
    // Name of the filter group the file-edit list is ordered by. This is a filter
    // group, not a row of the `asset_type` table.
    ASSET_TYPE_FILTER_NAME: 'Asset type',

    POPUPS_NAME: {
        CONFIRMED: 'confirmed',
    },

    SYSTEM_SETTINGS: {
        FREE_TIER_DAILY_DOWNLOADS: 'free_tier_daily_downloads_limit',
    },

    VALIDATION: {
        FREE_TIER_DOWNLOADS: {
            MIN: 1,
            MAX: 10000,
        },
    },

    SETTING_DISPLAY_NAMES: {
        free_tier_daily_downloads_limit: 'Free Tier Daily Downloads Limit',
    },

    URL: {
        // Asset Type
        ASSET_TYPE_GET: '/api-v2/asset_type/',
        ASSET_TYPE_CREATE: '/api-v2/asset_type/',
        ASSET_TYPE_UPDATE: '/api-v2/asset_type/update',
        ASSET_TYPE_UPDATE_IMAGE: '/api-v2/asset_type/upload_icon',

        // Provider and Game
        PROVIDER_AND_GAME_GET: '/api-v2/provider/spider',
        PROVIDER_GET: '/api-v2/provider/',
        PROVIDER_CLASSIFICATION_PROGRESS: '/api-v2/provider/classification-progress',
        PROVIDER_CLASSIFICATION_PROGRESS_ALL: '/api-v2/provider/classification-progress/all',
        PROVIDER_CREATE: '/api-v2/provider/',
        PROVIDER_DELETE: '/api-v2/provider/',
        PROVIDER_UPDATE: '/api-v2/provider/',
        PROVIDER_UPDATE_ICON: '/api-v2/provider/icon',
        GAME_GET: '/api-v2/provider/game',
        GAME_CREATE: '/api-v2/provider/game',
        GAME_DELETE: '/api-v2/provider/game',
        GAME_UPDATE: '/api-v2/provider/game',

        // File
        FILE_GET: '/api-v2/file_storage/admin',
        FILE_RELEASE: '/api-v2/file_storage/admin/release',
        FILE_RELEASE_ALL: '/api-v2/file_storage/admin/release_all',
        FILE_UPDATE: '/api-v2/file_storage/admin',
        FILE_DELETE: '/api-v2/file_storage/admin/unactive',
        FILE_EXCLUDE: '/api-v2/file_storage/admin/exclude',
        FILE_DISPUTES_RESOLVE: '/api-v2/file_storage/admin/disputes/resolve',
        FILE_DISPUTES_COUNT: '/api-v2/file_storage/admin/disputes/count',
        FILE_DISPUTES_SUMMARY: '/api-v2/file_storage/admin/disputes/summary',
        FILE_RECOVERY: '/api-v2/file_storage/admin/recover',
        FILE_MARK: '/api-v2/file_storage/admin/mark',
        FILE_FULL_IMAGE: '/api-v2/file_storage/full_image_url',

        // Filter
        FILTER_GET: '/api-v2/filter_api/filter',
        FILTER_CREATE: '/api-v2/filter_api/filter',
        FILTER_UPDATE: '/api-v2/filter_api/filter',
        FILTER_DELETE: '/api-v2/filter_api/filter',
        FILTER_SET_ICON: '/api-v2/filter_api/filter_icon',
        FILTER_ITEM_CREATE: '/api-v2/filter_api/filter_item',
        FILTER_ITEM_UPDATE: '/api-v2/filter_api/filter_item',
        FILTER_ITEM_DELETE: '/api-v2/filter_api/filter_item',

        // Smart Filter
        SMART_FILTER_GET: '/api-v2/smart_filters/',
        SMART_FILTER_CREATE: '/api-v2/smart_filters/',
        SMART_FILTER_UPDATE: '/api-v2/smart_filters/',
        SMART_FILTER_DELETE: '/api-v2/smart_filters/',
        SMART_FILTER_GET_USER: '/api-v2/smart_filters/user',

        // Authorization, User and Role
        AUTH_LOGIN: '/api-v2/auth/login',
        AUTH_REFRESH: '/api-v2/auth/refresh',
        AUTH_REGISTER: '/api-v2/auth/register',
        CAPTCHA_GENERATE: '/api-v2/captcha/generate',
        USER_GET: '/api-v2/user/',
        USER_UPDATE: '/api-v2/user/',
        USER_ACTIVE: '/api-v2/user/activate',
        USER_CHANGE_PASSWORD: '/api-v2/admin/users/{user_id}/change_password',
        ROLE_GET: '/api-v2/user/user_role',
        ROLE_CREATE: '/api-v2/user/user_role',
        ROLE_UPDATE: '/api-v2/user/user_role',
        ROLE_DELETE: '/api-v2/user/user_role',
        ROLE_ASSIGN: '/api-v2/user/user_role/assign',

        // User Sessions
        USER_SESSIONS_GET: '/api-v2/admin/users/{user_id}/sessions',
        USER_SESSION_DELETE:
            '/api-v2/admin/users/{user_id}/sessions/{session_id}',
        USER_DETAILS: '/api-v2/admin/users/{user_id}/details',
        ADMIN_USER_RESET_SUBSCRIPTION:
            '/api-v2/admin/users/{user_id}/reset_subscription_data',
        USER_HARD_DELETE: '/api-v2/admin/users/{user_id}/hard_delete',

        // Email Testing
        EMAIL_MODE: '/api-v2/admin/emails/mode',
        EMAILS_SENT: '/api-v2/admin/emails/sent',
        EMAILS_STATS: '/api-v2/admin/emails/stats',

        // Antifraud
        ANTIFRAUD_NOTIFICATIONS: '/api-v2/admin/antifraud/notifications',

        // Billing
        BILLING_PLANS: '/api-v2/billing/admin/plans',
        BILLING_PLAN_BY_ID: '/api-v2/billing/admin/plans/{plan_id}',
        BILLING_REFUNDS: '/api-v2/billing/admin/refunds',
        BILLING_REFUND_PROCESS:
            '/api-v2/billing/admin/refunds/{refund_id}/process',

        // Corporate Requests
        CORPORATE_REQUESTS: '/api-v2/admin/corporate_requests',
        CORPORATE_REQUEST_BY_ID:
            '/api-v2/admin/corporate_requests/{request_id}',
        CORPORATE_REQUEST_UPDATE_STATUS:
            '/api-v2/admin/corporate_requests/{request_id}/status',

        // Publisher Admin — Material Requests [Epic1/#869c5bjxn]
        ADMIN_MATERIAL_REQUESTS: '/api-v2/admin/provider_material_requests',
        ADMIN_MATERIAL_REQUEST_UPDATE_STATUS:
            '/api-v2/admin/provider_material_requests/{request_id}/status',
        ADMIN_MATERIAL_REQUEST_DOWNLOAD_FILE:
            '/api-v2/admin/provider_material_requests/{request_id}/files/{file_id}/download',

        // Publisher Admin — Publishers [Epic1/#869c5bjxn]
        ADMIN_PUBLISHERS: '/api-v2/admin/providers',
        ADMIN_PUBLISHER_STATUS: '/api-v2/admin/providers/{publisher_id}/status',
        // ADMIN_PUBLISHER_DELETE kept as alias — backend has no DELETE endpoint;
        // deleteAdminPublisher() uses ADMIN_PUBLISHER_STATUS with { status: 'deleted' }
        ADMIN_PUBLISHER_DELETE: '/api-v2/admin/providers/{publisher_id}/status',
        ADMIN_PUBLISHER_MIGRATE: '/api-v2/admin/providers/{publisher_id}/status',
        ADMIN_PROVIDER_VISIBILITY: '/api-v2/admin/providers/{provider_id}/visibility',
        ADMIN_PROVIDER_TEAM: '/api-v2/admin/providers/{provider_id}/team',

        // Publisher Admin — Guest Links [Epic1/#869c5bjxn]
        ADMIN_GUEST_LINKS: '/api-v2/admin/provider_guest_links',

        // Partner link system
        PARTNERS: '/api-v2/partners',
        PARTNER: '/api-v2/partners/{partner_id}',
        PARTNER_LINKS: '/api-v2/partners/{partner_id}/links',
        PARTNER_LINK: '/api-v2/partners/{partner_id}/links/{link_id}',
        PARTNER_LINK_FUNNEL: '/api-v2/partners/{partner_id}/links/{link_id}/funnel',
        PARTNER_COHORT_STATS: '/api-v2/partners/{partner_id}/cohort-stats',
        PARTNER_COHORT_STATS_CSV: '/api-v2/partners/{partner_id}/cohort-stats/export.csv',

        // Publisher Admin — Provider Assignments [Epic1/#869c5bjxn]
        ADMIN_USER_PROVIDER_ASSIGNMENTS: '/api-v2/admin/users/{user_id}/provider-assignments',
        ADMIN_USER_PROVIDER_ASSIGNMENT_DELETE: '/api-v2/admin/users/{user_id}/provider-assignments/{provider_id}',

        // Tag
        TAG_GET: '/api-v2/tags/',
        TAG_CREATE: '/api-v2/tags/',
        TAG_DELETE: '/api-v2/tags/',
        TAG_UPDATE: '/api-v2/tags/',
        TAG_PARSE: '/api-v2/file_storage/admin/parse_additional_tags_to_tags',

        // User Analytics
        USER_ANALYTICS: '/api-v2/admin/analytics/users',
        USER_ANALYTICS_REFRESH: '/api-v2/admin/analytics/users/refresh',
        USER_ANALYTICS_REFRESH_STATUS:
            '/api-v2/admin/analytics/users/refresh/status',
        USER_ANALYTICS_EXPORT: '/api-v2/admin/analytics/users/export',

        // Search Query Analytics
        SEARCH_QUERY_ANALYTICS: '/api-v2/admin/analytics/search_queries',

        // System Analytics
        SYSTEM_ANALYTICS_DAILY_FILE_UPLOADS: '/api-v2/admin/analytics/daily_file_uploads',

        // System Settings
        SYSTEM_SETTINGS: '/api-v2/admin/system_settings',

        // Chat GPT
        CHAT_GET_IMAGE_DESCRIPTION: '/api-v2/image_description/',
        IMAGE_CLASSIFICATION: '/api-v2/image_classification/',
        PROMPT_GET: '/api-v2/image_description/prompt',
        PROMPT_CREATE: '/api-v2/image_description/prompt',
        PROMPT_UPDATE: '/api-v2/image_description/prompt',
        PROMPT_DELETE: '/api-v2/image_description/prompt',
    },

    // User Analytics Constants
    FILTER_ALL: 'all',
    DEBOUNCE_DELAY_MS: 300,

    REFRESH_STATUS: {
        IDLE: 'idle',
        REFRESHING: 'refreshing',
        FAILED: 'failed',
    },

    ENGAGEMENT_TIERS: [
        {
            value: 'never_active',
            label: 'Never Active',
            hint: '0 days active — Registered but never engaged',
        },
        {
            value: 'one_day_visitor',
            label: 'One-Day Visitor',
            hint: '1 day active — Tried the platform once',
        },
        {
            value: 'casual_visitor',
            label: 'Casual Visitor',
            hint: '2–3 days active — Occasional usage',
        },
        {
            value: 'weekly_user',
            label: 'Weekly User',
            hint: '4–7 days active — Regular weekly visitor',
        },
        {
            value: 'regular_user',
            label: 'Regular User',
            hint: '8–30 days active — Reliable, consistent user',
        },
        {
            value: 'power_user',
            label: 'Power User',
            hint: '31+ days active — Core user, heavy usage',
        },
    ],

    RECENCY_STATUSES: [
        {
            value: 'never_active',
            label: 'Never Active',
            hint: 'No activity recorded',
        },
        {
            value: 'active_this_week',
            label: 'Active This Week',
            hint: 'Last active within 7 days',
        },
        {
            value: 'active_this_month',
            label: 'Active This Month',
            hint: 'Last active 8–30 days ago',
        },
        {
            value: 'dormant',
            label: 'Dormant',
            hint: 'Last active 31–90 days ago',
        },
        {
            value: 'churned',
            label: 'Churned',
            hint: 'Last active 90+ days ago',
        },
    ],

    PERMISSIONS: [
        {
            name: 'Activate Users',
            id: 'can_activate_users',
        },
        {
            name: 'Add Roles',
            id: 'can_add_roles',
        },
        {
            name: 'Assign Roles',
            id: 'can_assign_roles',
        },
        {
            name: 'Delete Files',
            id: 'can_delete_files',
        },
        {
            name: 'Delete Games',
            id: 'can_delete_games',
        },
        {
            name: 'Edit Asset Types',
            id: 'can_edit_asset_types',
        },
        {
            name: 'Edit Files',
            id: 'can_edit_files',
        },
        {
            name: 'Edit Filters',
            id: 'can_edit_filters',
        },
        {
            name: 'Edit Games',
            id: 'can_edit_games',
        },
        {
            name: 'Edit Prompts',
            id: 'can_edit_prompts',
        },
        {
            name: 'Edit Providers',
            id: 'can_edit_providers',
        },
        {
            name: 'Edit Smart Filters',
            id: 'can_edit_smart_filters',
        },
        {
            name: 'Edit Tags',
            id: 'can_edit_tags',
        },
        {
            name: 'Release Files',
            id: 'can_release_files',
        },
        {
            name: 'Use Admin',
            id: 'can_use_admin',
        },
        // [Epic1/#869c5bjxn] Publisher Admin permission
        {
            name: 'Manage Publishers',
            id: 'can_manage_publishers',
        },
    ],
    FILE_STATUS: [
        {
            id: 'active',
            name: 'Active',
        },
        {
            id: 'disable',
            name: 'Disable',
        },
        {
            id: 'release',
            name: 'Release',
        },
        {
            id: 'unrelease',
            name: 'Unrelease',
        },
    ],
    ADDITIONAL_STATUS: [
        {
            id: 'just_created',
            name: 'Just created',
        },
        {
            id: 'just_updated_by_spider',
            name: 'Just updated by spider',
        },
        {
            id: 'just_updated_from_admin',
            name: 'Just updated from admin',
        },
        {
            id: 'marked_for_deletion',
            name: 'Marked for delete',
        },
        {
            id: 'marked_for_update',
            name: 'Marked for update',
        },
    ],
    MAIN_COLOR: [
        {
            name: 'brown',
            color: MAIN_COLOR.brown.MAIN,
            color_hover: MAIN_COLOR.brown.MAIN_2UP,
        },
        {
            name: 'blue',
            color: MAIN_COLOR.blue.MAIN,
            color_hover: MAIN_COLOR.blue.MAIN_2UP,
        },
        {
            name: 'orange',
            color: MAIN_COLOR.orange.MAIN,
            color_hover: MAIN_COLOR.orange.MAIN_2UP,
        },
        {
            name: 'purple',
            color: MAIN_COLOR.purple.MAIN,
            color_hover: MAIN_COLOR.purple.MAIN_2UP,
        },
        {
            name: 'custom',
            color: '#ffffff',
            color_hover: '#cccccc',
        },
        {
            name: 'green',
            color: MAIN_COLOR.green.MAIN,
            color_hover: MAIN_COLOR.green.MAIN_2UP,
        },
        {
            name: 'pink',
            color: MAIN_COLOR.pink.MAIN,
            color_hover: MAIN_COLOR.pink.MAIN_2UP,
        },
    ],
    FILTER_TYPE: [
        {
            id: 'checkbox',
            name: 'Checkbox',
            description:
                'The standard type for filters, all filter elements will be displayed with the checkbox as a list.',
        },
        {
            id: 'tag',
            name: 'Tag',
            description:
                'All filter elements will be displayed as tags with hiding most of the elements in separate popups.',
        },
        {
            id: 'popup',
            name: 'Popup',
            description:
                "It is displayed as a checkbox, but only the elements with the 'is_default' field are displayed, the rest are hidden in a separate popup.",
        },
        {
            id: 'asset_type',
            name: 'Asset Type',
            description:
                'A unique type for the "Asset type", raises the filter in the hierarchy and allows you to additionally output near the search bar.',
        },
    ],

    DEFAULT_FILE_STATUS: 'active',
    DEFAULT_PROMPT_NAME: 'default',
    DEFAULT_ADDITIONAL_STATUS: 'all',
    DEFAULT_PROVIDER: 'all',
    DEFAULT_GAME: 'all',

    // Corporate Requests
    CORPORATE_REQUEST_STATUS: {
        ALL: 'all',
        PENDING: 'pending',
        CONTACTED: 'contacted',
        CONVERTED: 'converted',
        REJECTED: 'rejected',
    },

    CORPORATE_REQUEST_STATUS_CONFIG: {
        pending: {
            text: 'Pending',
            cssClass: 'status_pending',
            background: '#fff3cd',
            color: '#856404',
            border: '#ffc107',
        },
        contacted: {
            text: 'Contacted',
            cssClass: 'status_contacted',
            background: '#d1ecf1',
            color: '#0c5460',
            border: '#17a2b8',
        },
        converted: {
            text: 'Converted',
            cssClass: 'status_converted',
            background: '#d4edda',
            color: '#155724',
            border: '#28a745',
        },
        rejected: {
            text: 'Rejected',
            cssClass: 'status_rejected',
            background: '#f8d7da',
            color: '#721c24',
            border: '#dc3545',
        },
    },

    // Colors
    COLOR: {
        GREEN: '#00d25b',
        RED: '#ff4444',
        ORANGE: '#ff9800',
    },

    // Auto-refresh intervals
    AUTO_REFRESH_INTERVALS: {
        PENDING_COUNT: 30000, // 30 seconds
    },

    // API Request Names
    API_REQUEST_NAMES: {
        GET_CORPORATE_REQUESTS: 'GET CORPORATE REQUESTS',
        GET_CORPORATE_REQUEST: 'GET CORPORATE REQUEST',
        UPDATE_CORPORATE_REQUEST_STATUS: 'UPDATE CORPORATE REQUEST STATUS',
        // [Epic1/#869c5bjxn] Publisher Admin
        GET_ADMIN_MATERIAL_REQUESTS: 'GET ADMIN MATERIAL REQUESTS',
        UPDATE_ADMIN_MATERIAL_REQUEST_STATUS: 'UPDATE ADMIN MATERIAL REQUEST STATUS',
        DOWNLOAD_ADMIN_MATERIAL_REQUEST_FILE: 'DOWNLOAD ADMIN MATERIAL REQUEST FILE',
        GET_ADMIN_PUBLISHERS: 'GET ADMIN PUBLISHERS',
        DELETE_ADMIN_PUBLISHER: 'DELETE ADMIN PUBLISHER',
        MIGRATE_ADMIN_PUBLISHER: 'MIGRATE ADMIN PUBLISHER',
        GET_ADMIN_GUEST_LINKS: 'GET ADMIN GUEST LINKS',
        GET_USER_PROVIDER_ASSIGNMENTS: 'GET USER PROVIDER ASSIGNMENTS',
        ASSIGN_PROVIDER_TO_USER: 'ASSIGN PROVIDER TO USER',
        REMOVE_PROVIDER_FROM_USER: 'REMOVE PROVIDER FROM USER',
        UPDATE_PROVIDER_VISIBILITY: 'UPDATE PROVIDER VISIBILITY',
        GET_PROVIDER_TEAM: 'GET PROVIDER TEAM',
        // Partner link system
        GET_PARTNERS: 'GET PARTNERS',
        CREATE_PARTNER: 'CREATE PARTNER',
        UPDATE_PARTNER: 'UPDATE PARTNER',
        DELETE_PARTNER: 'DELETE PARTNER',
        GET_PARTNER_LINKS: 'GET PARTNER LINKS',
        CREATE_PARTNER_LINK: 'CREATE PARTNER LINK',
        DELETE_PARTNER_LINK: 'DELETE PARTNER LINK',
        GET_PARTNER_LINK_FUNNEL: 'GET PARTNER LINK FUNNEL',
        GET_PARTNER_COHORT_STATS: 'GET PARTNER COHORT STATS',
        EXPORT_PARTNER_COHORT_STATS: 'EXPORT PARTNER COHORT STATS',
    },

    // Pagination
    PAGINATION: {
        DEFAULT_PAGE_SIZE: 20,
        DEFAULT_PAGE: 1,
        DEFAULT_LIMIT: 100,
        DEFAULT_OFFSET: 0,
    },

    // [Epic1/#869c5bjxn] Material Request types and statuses
    MATERIAL_REQUEST_TYPE: {
        ARCHIVE: 'archive',
        LINK: 'link',
    },

    MATERIAL_REQUEST_STATUS: {
        NEW: 'new',
        IN_PROGRESS: 'in_progress',
        DONE: 'done',
        REJECTED: 'rejected',
    },

    MATERIAL_REQUEST_STATUS_CONFIG: {
        new: {
            text: 'New',
            cssClass: 'status_new',
            background: '#f3f4f6',
            color: '#374151',
            border: '#d1d5db',
        },
        in_progress: {
            text: 'In Progress',
            cssClass: 'status_in_progress',
            background: '#dbeafe',
            color: '#1e40af',
            border: '#93c5fd',
        },
        done: {
            text: 'Done',
            cssClass: 'status_done',
            background: '#d1fae5',
            color: '#065f46',
            border: '#6ee7b7',
        },
        rejected: {
            text: 'Rejected',
            cssClass: 'status_rejected_mr',
            background: '#fee2e2',
            color: '#991b1b',
            border: '#fca5a5',
        },
    },
};
